import { MessageSquare } from 'lucide-react'
import { gtmEvents } from '@/lib/gtm'
import { Button } from '@/components/ui/button'

export const FloatingWhatsApp = () => {
  return (
    <div className="fixed bottom-6 right-6 z-40">
      <Button
        asChild
        className="rounded-full h-12 w-12 bg-[#25D366] hover:bg-[#128C7E] text-white shadow-lg p-0"
        onClick={() =>
          gtmEvents.custom('click_whatsapp', { location: 'floating_button' })
        }
      >
        <a
          href="https://wa.me/5511999999999"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contato via WhatsApp"
        >
          <MessageSquare className="h-6 w-6" />
        </a>
      </Button>
    </div>
  )
}
